import { useContext } from 'react'
import styled from 'styled-components'

import { MODALS_ID } from '../../../constants'

import { ModalContext } from '../../../provider/modalProvider'

import { Button } from '../../../components/button'
import { Modal } from '../../../components/modal'
import { Text } from '../../../components/text'

import { InvestSuitabilityTestModal } from '../../myPage/modals/InvestSuitabilityTestModal'

export function SuitableNoticeModal() {
  const { openModal, closeModal } = useContext(ModalContext)

  const openInvestTestModal = () => {
    openModal({
      id: MODALS_ID.INVEST_SUITABILITY,
      Component: () => <InvestSuitabilityTestModal onDismiss={closeInvestTestModal} />,
    })
  }

  const closeInvestTestModal = () => {
    closeModal(MODALS_ID.INVEST_SUITABILITY)
  }

  return (
    <Modal id={MODALS_ID.SUITABLE_NOTICE}>
      <Content>
        <Text size={18} weight={600} block={true}>
          투자 적합성 테스트 안내
        </Text>
        <Text size={14} weight={500} lineHeight={20} color="text_secondary" block={true}>
          1. 테스트 단계에서모든 문제를 맞추셔야 투자를 진행 하실 수 있습니다.
          <br />
          2. 투자위험 인지 여부 확인을 위한 테스트로, 회원님의 정보는 테스트 후 2년간 유효합니다.
        </Text>
      </Content>
      <Modal.Footer>
        <Button type="primary" block={true} onClick={openInvestTestModal}>
          테스트하기
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  text-align: center;
`
